import React from 'react';
import PropTypes from 'prop-types';
import { MultimediaAdBidAdjustment } from './multimedia-ad-bid-adjustment';
import { AutomatedCallToActionOptOut } from './automated-cta';
import { SwitchUseCampaignSetting } from './switch-use-campaign-setting';

export const MultimediaAdBidAdjustmentSettings = ({
  onDataChange, data, level,
}) => {
  const { multimediaAds } = data;
  const onUseParentLevelChange = (newData) => {
    let { currentLevelData } = newData;
    if (!newData.useParentLevel && currentLevelData.bidAdjustmentInput === null) {
      currentLevelData = newData.parentLevelData;
    }

    onDataChange({
      multimediaAds: {
        ...newData,
        currentLevelData,
      },
    });
  };

  return (
    <div>
      <SwitchUseCampaignSetting
        level={level}
        onDataChange={onUseParentLevelChange}
        data={multimediaAds}
      />
      <MultimediaAdBidAdjustment
        onDataChange={onDataChange}
        data={data}
        level={level}
      />
      <AutomatedCallToActionOptOut
        data={data}
        onDataChange={onDataChange}
        level={level}
      />
    </div>
  );
};

MultimediaAdBidAdjustmentSettings.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    multimediaAds: PropTypes.shape({
      currentLevelData: PropTypes.shape({
        bidAdjustmentDropdown: PropTypes.string,
        bidAdjustmentInput: PropTypes.number,
      }),
      parentLevelData: PropTypes.shape({
        bidAdjustmentDropdown: PropTypes.string,
        bidAdjustmentInput: PropTypes.number,
      }),
      useParentLevel: PropTypes.bool,
    }),
  }).isRequired,
  level: PropTypes.string.isRequired,
};
